/**
 * Return the last item from an array
 * @param array
 */ function last(array) {
    if (array.length > 0) {
        return array[array.length - 1];
    }
    return undefined;
}
function second(tuple) {
    return tuple[1];
}
function take(amount, array) {
    return array.length < amount ? [
        ...array
    ] : [
        ...array.slice(0, amount)
    ];
}
/**
 * Take the last `amount` items from an array.
 * @param amount How many items to take from the end of the array. If amount is greater than the length of the array, we return a copy of the full array
 * @param array
 */ function takeLast(amount, array) {
    return array.length < amount ? [
        ...array
    ] : array.slice(-amount);
}
function first(array) {
    return array.length > 0 ? array[0] : null;
}
export { first, second, last, take, takeLast };
